import { render, staticRenderFns } from "./PublisherSettings.vue?vue&type=template&id=037114e4&scoped=true&lang=pug&"
import script from "./PublisherSettings.vue?vue&type=script&lang=js&"
export * from "./PublisherSettings.vue?vue&type=script&lang=js&"
import style0 from "./PublisherSettings.vue?vue&type=style&index=0&id=037114e4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037114e4",
  null
  
)

export default component.exports